import firebase from 'firebase/app';
import config from 'config';
import 'firebase/auth';
import 'firebase/messaging';

const firebaseConfig = {
    appId: config.FIREBASE_APP_ID,
    apiKey: config.FIREBASE_API_KEY,
    authDomain: config.FIREBASE_AUTH_DOMAIN,
    databaseURL: config.FIREBASE_DATABASE_URL,
    projectId: config.FIREBASE_PROJECT_ID,
    storageBucket: config.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
    measurementId: config.FIREBASE_MEASUREMENT_ID,
};
firebase.initializeApp(firebaseConfig);
// const messaging = firebase.messaging();

export { firebase };
